
export default ['resizeImage', function () {
    'ngInject';

    return function (value, width, height) {
        var separate = String(value).split('.');

        if (value) {
            return separate[0] + 'size-' + width + '-' + height + '.' + separate[1];
        }

        return '';
    };
}];



// WEBPACK FOOTER //
// ./src/app/filters/resizeImage.js